import { useToast } from "@/hooks/useToast";
import { cn } from "@/lib/utils";

/** Renders the toast stack (docs/08 §8.13). */
export function Toaster() {
  const { toasts, dismiss } = useToast();
  if (toasts.length === 0) return null;

  return (
    <div
      // Announced politely so a save confirmation does not interrupt typing.
      role="status"
      aria-live="polite"
      className="pointer-events-none fixed inset-x-0 bottom-0 z-50 flex flex-col items-center gap-2 p-4"
    >
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={cn(
            "pointer-events-auto flex w-full max-w-md items-start gap-3 rounded-lg px-4 py-3 shadow-lg ring-1",
            toast.tone === "success" && "bg-white text-green-900 ring-green-200",
            toast.tone === "error" && "bg-white text-red-900 ring-red-200",
            toast.tone === "info" && "bg-white text-slate-900 ring-slate-200",
          )}
        >
          <p className="flex-1 text-sm">{toast.message}</p>
          {toast.action && (
            <button
              type="button"
              onClick={() => {
                toast.action?.onClick();
                dismiss(toast.id);
              }}
              className="text-sm font-semibold text-brand-700 underline"
            >
              {toast.action.label}
            </button>
          )}
          <button
            type="button"
            onClick={() => dismiss(toast.id)}
            className="rounded px-1 text-slate-400 hover:text-slate-700"
            aria-label="Dismiss"
          >
            &times;
          </button>
        </div>
      ))}
    </div>
  );
}
